"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ArticleBottomItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TextBoxWithLinks = _interopRequireDefault(require("./TextBoxWithLinks/TextBoxWithLinks"));
var _Interview = _interopRequireDefault(require("./Interview/Interview"));
var _Citation = _interopRequireDefault(require("./Citation/Citation"));
var _List = _interopRequireDefault(require("../../List/List"));
var _DownloadLinkBox = _interopRequireDefault(require("../../DownloadLinkBox/DownloadLinkBox"));
var _InterviewMulti = _interopRequireDefault(require("./InterviewMulti/InterviewMulti"));
var _PagePicture = _interopRequireDefault(require("../../PagePicture/PagePicture"));
var _ArticleBoxArea = _interopRequireDefault(require("../../ArticleBoxArea/ArticleBoxArea"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.sia-article-bottom {\n  display: flex;\n  flex-direction: column;\n  /*\r\n  .first-row {\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  }\r\n  .rest {\r\n    grid-template-columns: repeat(3, minmax(0, 1fr));\r\n  }\r\n  */ }\n";
  const fileName = "ArticleBottom_ArticleBottom";
  const element = document.querySelector("style[data-sass-component='ArticleBottom_ArticleBottom']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const ArticleBottomItem = _ref => {
  let {
    item,
    lang,
    history,
    translate,
    ...rest
  } = _ref;
  if (item.paragraph_type === 'text_box_col_withlinks') {
    return /*#__PURE__*/_react.default.createElement(_TextBoxWithLinks.default, {
      items: item.text_box_elements,
      lang: lang
    });
  }
  if (item.paragraph_type === 'list') {
    return /*#__PURE__*/_react.default.createElement(_List.default, {
      title: item.title || '',
      items: item.paragraph_multi?.map(el => {
        return {
          content: el
        };
      }),
      variant: item.list_type.name.toUpperCase()
    });
  }
  if (item.paragraph_type === 'link_downloads_box') {
    return /*#__PURE__*/_react.default.createElement(_DownloadLinkBox.default, {
      items: item?.link_downloads_box_element,
      lang: lang
    });
  }
  if (item.paragraph_type === 'picture') {
    if (!item.picture) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    return /*#__PURE__*/_react.default.createElement(_PagePicture.default, {
      src: item.picture[0]?.original?.url,
      srcTablet: item.picture[0]?.tablet?.url,
      srcMobile: item.picture[0]?.mobile?.url,
      copyright: {
        title: item.picture[0]?.title,
        copyright: item.picture[0]?.copyright
      }
    });
  }
  if (item.paragraph_type === 'interview') {
    return /*#__PURE__*/_react.default.createElement(_Interview.default, {
      item: item,
      lang: lang
    });
  }
  if (item.paragraph_type === 'interview_multi') {
    return /*#__PURE__*/_react.default.createElement(_InterviewMulti.default, {
      item: item,
      lang: lang
    });
  }
  if (item.paragraph_type === 'citation') {
    return /*#__PURE__*/_react.default.createElement(_Citation.default, _extends({}, item, {
      lang: lang
    }));
  }
  if (item.paragraph_type === 'article_boxes_area') {
    return /*#__PURE__*/_react.default.createElement(_ArticleBoxArea.default, _extends({
      lang: lang,
      items: item.articles,
      history: history,
      translate: translate
    }, rest));
  }
  if (item.paragraph_type) {
    return /*#__PURE__*/_react.default.createElement("p", {
      className: "sia-padding-02-bottom"
    }, "TO DO:", item.paragraph_type);
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};
exports.ArticleBottomItem = ArticleBottomItem;
const ArticleBottom = _ref2 => {
  let {
    items,
    lang,
    history,
    translate
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-article-bottom sia-padding-05-top"
  }, Object.values(items).map((item, index) => {
    return /*#__PURE__*/_react.default.createElement(ArticleBottomItem, {
      key: index,
      item: item,
      lang: lang,
      history: history,
      translate: translate
    });
  }));
};
ArticleBottom.propTypes = {
  items: _propTypes.default.oneOfType([_propTypes.default.object.isRequired, _propTypes.default.array.isRequired]),
  lang: _propTypes.default.string.isRequired
};
var _default = exports.default = ArticleBottom;